import React from 'react'
import { useTranslation } from 'react-i18next'
import { 
    Flex, 
    Heading, 
    Image, 
    Modal, 
    ModalBody, 
    ModalCloseButton, 
    ModalContent, 
    ModalOverlay, 
    Text, 
} from '@chakra-ui/react'
import { 
    IC_ATTENDANCE_IN, 
    IC_ATTENDANCE_OUT, 
    IC_AUTO_UPDATE, 
    IC_CHECK_IN, 
    IC_CHECK_IN_LEADS, 
    IC_CHECK_OUT, 
    IC_COMPLETE_LEADS, 
    IC_DRAFT, 
    IC_OUT_ZONE, 
    IC_RESULT, 
    IC_UDPATE_LEADS, 
    IL_ATTENDANCE_ZONE, 
    IL_CHECK_IN, 
    IL_LIVE_TRACKING, 
} from '../../../assets'
import { JTypography } from '../../../components'

interface IJourneyLegend {
    isOpen: boolean
    onClose: any
}

const JourneyLegend = (props: IJourneyLegend) => {
    const { t } = useTranslation()
    const { isOpen, onClose } = props

    return (
        <Modal isOpen={isOpen} onClose={onClose} size="xl" isCentered>
            <ModalOverlay />
            <ModalContent bgColor="var(--colorSurface)" mx="10px">
                <ModalCloseButton />
                <ModalBody p="16px" width='584px'>
                    <Heading size='chakra_title_medium' fontSize='22px' fontWeight='400'>{t("perjalanan_legenda")}</Heading>
                    <Flex gap="24px" marginTop='24px'>
                        <Flex direction="column" gap="16px">
                            <Flex direction="column" gap="8px">
                                <Heading size='chakra_title_small'>{t("modal_legenda_zona_live_tracking")}</Heading>
                                <Image height='101px' objectFit='cover' borderRadius='4px' src={IL_LIVE_TRACKING} />
                            </Flex>
                            <Flex direction="column" gap="8px">
                                <Heading size='chakra_title_small'>{t("modal_legenda_zona_check_in")}</Heading>
                                <Image height='101px' objectFit='cover' borderRadius='4px' src={IL_CHECK_IN} />
                            </Flex>
                            <Flex direction="column" gap="8px">
                                <Heading size='chakra_title_small'>{t("modal_legenda_zona_attendance")}</Heading>
                                <Image height='101px' objectFit='cover' borderRadius='4px' src={IL_ATTENDANCE_ZONE} />
                            </Flex>
                        </Flex>
                        <Flex direction="column" gap="12px">
                            <Flex gap="16px" alignItems="center">
                                <Image width='24px' height='24px' src={IC_ATTENDANCE_IN} />
                                <Heading size='chakra_title_small'>
                                    {t("modal_legenda_absen_masuk")}
                                </Heading>
                            </Flex>
                            <Flex gap="16px" alignItems="center">
                                <Image width='24px' height='24px' src={IC_ATTENDANCE_OUT} />
                                <Heading size='chakra_title_small'>
                                    {t("modal_legenda_absen_keluar")}
                                </Heading>
                            </Flex>
                            <Flex gap="16px" alignItems="center">
                                <Image width='24px' height='24px' src={IC_AUTO_UPDATE} />
                                <Heading size='chakra_title_small'>
                                    {t("modal_legenda_auto_update")}
                                </Heading>
                            </Flex>
                            <Flex gap="16px" alignItems="center">
                                <Image width='24px' height='24px' src={IC_CHECK_IN} />
                                <Heading size='chakra_title_small'>
                                    {t("modal_legenda_check_in")}
                                </Heading>
                            </Flex>
                            <Flex gap="16px" alignItems="center">
                                <Image width='24px' height='24px' src={IC_DRAFT} />
                                <Heading size='chakra_title_small'>
                                    {t("modal_legenda_draf")}
                                </Heading>
                            </Flex>
                            <Flex gap="16px" alignItems="center">
                                <Image width='24px' height='24px' src={IC_CHECK_OUT} />
                                <Heading size='chakra_title_small'>
                                    {t("modal_legenda_check_out")}
                                </Heading>
                            </Flex>
                            <Flex gap="16px" alignItems="center">
                                <Image width='24px' height='24px' src={IC_RESULT} />
                                <Heading size='chakra_title_small'>
                                    {t("modal_legenda_hasil")}
                                </Heading>
                            </Flex>
                            <Flex gap="16px" alignItems="center">
                                <Image width='24px' height='24px' src={IC_OUT_ZONE} />
                                <Heading size='chakra_title_small'>
                                    {t("modal_legenda_keluar_dari_zona_tracking")}
                                </Heading>
                            </Flex>
                            <Flex gap="16px" alignItems="center">
                                <Image width='24px' height='24px' src={IC_CHECK_IN_LEADS} />
                                <Heading size='chakra_title_small'>
                                    {t("perjalanan_checkin_leads")}
                                </Heading>
                            </Flex>
                            <Flex gap="16px" alignItems="center">
                                <Image width='24px' height='24px' src={IC_COMPLETE_LEADS} />
                                <Heading size='chakra_title_small'>
                                    {t("perjalanan_complete_leads")}
                                </Heading>
                            </Flex>
                            <Flex gap="16px" alignItems="center">
                                <Image width='24px' height='24px' src={IC_UDPATE_LEADS} />
                                <Heading size='chakra_title_small'>
                                    {t("perjalanan_update_leads")}
                                </Heading>
                            </Flex>
                        </Flex>
                    </Flex>
                </ModalBody>
            </ModalContent>
        </Modal>
    )
}

export default JourneyLegend